<template>
  <div
    class="flex flex-col py-4 bg-white mb-3"
    :style="{
      borderRadius: '4px',
      border: notFilled ? '1.8px solid red' : '',
    }"
  >
    <vs-col
      vs-w="12"
      vs-type="flex"
      vs-align="center"
      vs-justify="space-between"
    >
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="AwardIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        ></feather-icon>
        <h4>Experiências</h4>
      </div>

      <vs-button
        class="mobile-hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      >
        Editar
      </vs-button>

      <vs-button
        class="sm:hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      />
    </vs-col>

    <hr class="my-4 line" />

    <ul v-if="show()" class="activity-timeline">
      <li v-for="(experience, index) in experiencies" :key="`step-${index}`">
        <div
          class="timeline-icon"
          :style="{ backgroundColor: color }"
          :key="`timeline-${index}`"
        >
          <feather-icon
            icon="BriefcaseIcon"
            svgClasses="text-white stroke-current w-5 h-5"
          ></feather-icon>
        </div>
        <div
          class="exp-detail__date"
          v-if="
            experience.from_date != null ||
            (experience.from_date != undefined && experience.to_date != null) ||
            (experience.to_date != undefined && experience.period != null) ||
            experience.period != undefined
          "
        >
        {{
            (experience.from_date) ? 
              experience.from_date
                .concat(` até ${experience.is_current ? 'Atualmente' : experience.to_date }`)
                .concat(
                  experience.is_current
                    ? '' 
                    : ` (${experience.period})`
                )
              :
              (
                ((experience.from_date === null || experience.from_date === undefined) && experience.to_date) 
                  ? 'Início Não Informado - ' + experience.to_date
                  : experience.from_date + '- Não Informado' )
          }}
        </div>
        <div
          class="exp-detail__company"
          v-if="
            experience.business_role != null ||
            (experience.business_role != undefined &&
              exprience.company != null) ||
            experience.company != undefined
          "
        >
          {{ experience.business_role.concat(` - ${experience.company}`) }}
        </div>
        <div
          class="exp-detail__description"
          v-if="
            experience.description != null ||
            experience.description != undefined
          "
        >
          {{ experience.description }}
        </div>
        <div v-if="experience.skills.length > 0" class="exp-detail--skills">
          <span class="exp-detail--skills__title"
            >Habilidades e Ferramentas:</span
          >
          <div class="exp-detail--skills__chip" :style="{ color: color }">
            <div
              class="chip"
              :style="{ borderColor: color }"
              v-for="(skill, index) in experience.skills"
              :key="`chip-${index}`"
            >
              {{ skill }}
            </div>
          </div>
        </div>
      </li>
    </ul>
    <EmptyDetailCard
      v-else
      description="Você ainda não preencheu nenhuma informação de experiências..."
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  name: "simple-experience",
  props: {
    notFilled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("experience", ["experiencies"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    navigateToSelectedStep() {
      this.updateCurrentStep({ order: 5 });
      this.$router.push({ name: "step-experiences" });
    },

    show() {
      return this.experiencies.length > 0;
    },

    ...mapActions("step", ["updateCurrentStep"]),
  },
  components: {
    EmptyDetailCard,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/resume/simple.scss";
.exp-detail-card {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
}

.exp-detail__date {
  color: #868ba1;
}

.exp-detail__company {
  color: black;
  font-size: 1rem;
}

.exp-detail__description {
  color: #868ba1;
}

.exp-detail--skills {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}

.exp-detail--skills__title {
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: black;
}

.exp-detail--skills__chip {
  display: flex;
  flex-wrap: wrap;

  & .chip {
    margin: 0.25rem;
    padding: 0.15rem 0.5rem;
    border: 1px solid;
    border-radius: 5px;

    font-weight: bold;
  }
}

.exp-detail--bg__purple {
  background-color: #9a4fba !important;
}
</style>
